import * as moment from "moment-timezone";
import {ValueAndLabelModel} from "../../model/valueAndLabel.model";

export class CustomDateModel {
    type: ValueAndLabelModel;
    date: moment.Moment;
}